import { render, staticRenderFns } from "./ControlActionHistories.vue?vue&type=template&id=83aaabb8&scoped=true&"
import script from "./ControlActionHistories.vue?vue&type=script&lang=js&"
export * from "./ControlActionHistories.vue?vue&type=script&lang=js&"
import style0 from "./ControlActionHistories.vue?vue&type=style&index=0&id=83aaabb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aaabb8",
  null
  
)

export default component.exports